module.exports = __webpack_public_path__ + "img/rulesImg.b44cc56b.webp";